import React, { useState, useEffect, useReducer, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IMAGES } from "../constants/theme";

import Collapse from "react-bootstrap/Collapse";
import { MenuListArray2 } from "./MenuListArray2";
import BannerSlider from "../components/BannerSlider";
import { useAuth } from "../auth/AuthContext";
import { INSTAGRAM_URL } from "../utils/whatsapp";
import apiClient from "../api/apiClient";
import { useLanguage } from "../i18n/LanguageContext";

const Header2 = () => {
  /* for sticky header */
  const [headerFix, setheaderFix] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { isArabic, t, toggleLanguage } = useLanguage();
  const [activeMenu, setActiveMenu] = useState("");
  const [nutritionGuideAccess, setNutritionGuideAccess] = useState(false);

  useEffect(() => {
    let cancelled = false;

    if (!user) {
      setNutritionGuideAccess(false);
      return undefined;
    }

    apiClient.get("/features/nutrition_guide/access")
      .then(({ data }) => {
        if (!cancelled) setNutritionGuideAccess(Boolean(data.has_access));
      })
      .catch(() => {
        if (!cancelled) setNutritionGuideAccess(false);
      });

    return () => {
      cancelled = true;
    };
  }, [user]);
  useEffect(() => {
    const onScroll = () => {
      setheaderFix(window.scrollY > 50);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  useEffect(() => {
    const updateHeaderStackHeight = () => {
      const banner = document.querySelector(".banner-slider");
      const headerBar = document.querySelector(".site-header.style-2 .main-bar");
      const bannerHeight = banner ? banner.getBoundingClientRect().height : 0;
      const headerHeight = headerBar ? headerBar.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty(
        "--hpa-header-stack-height",
        `${Math.ceil(bannerHeight + headerHeight)}px`
      );
    };

    updateHeaderStackHeight();

    const resizeObserver = "ResizeObserver" in window ? new ResizeObserver(updateHeaderStackHeight) : null;
    const mutationObserver = "MutationObserver" in window ? new MutationObserver(updateHeaderStackHeight) : null;

    const observeTargets = () => {
      resizeObserver?.disconnect();
      const banner = document.querySelector(".banner-slider");
      const headerBar = document.querySelector(".site-header.style-2 .main-bar");
      if (banner) resizeObserver?.observe(banner);
      if (headerBar) resizeObserver?.observe(headerBar);
      updateHeaderStackHeight();
    };

    observeTargets();
    mutationObserver?.observe(document.body, { childList: true, subtree: true });
    window.addEventListener("resize", updateHeaderStackHeight);

    return () => {
      resizeObserver?.disconnect();
      mutationObserver?.disconnect();
      window.removeEventListener("resize", updateHeaderStackHeight);
      document.documentElement.style.removeProperty("--hpa-header-stack-height");
    };
  }, []);

  useEffect(() => {
    var mainMenu = document.getElementById("OpenMenu");
    if (mainMenu) {
      if (sidebarOpen) {
        mainMenu.classList.add("show");
      } else {
        mainMenu.classList.remove("show");
      }
    }
  });

  // Menu dropdown list
  const reducer = (previousState, updatedState) => ({
    ...previousState,
    ...updatedState,
  });
  const initialState = {
    active: "",
    activeSubmenu: "",
  };
  const [state, setState] = useReducer(reducer, initialState);
  const handleMenuActive = (status) => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: "" });
    }
  };
  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status });
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" });
    }
  };

  function AddActiveMenu() {
    MenuListArray2?.forEach((ell) => {
      if (ell.to === location.pathname) {
        setActiveMenu(ell.title);
      }
      ell.content?.forEach((ele) => {
        if (ele.to === location.pathname) {
          setActiveMenu(ell.title);
        }
      });
    });
  }
  useMemo(AddActiveMenu, [location.pathname]);

  const closeMobileMenu = () => setSidebarOpen(false);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") setSidebarOpen(false);
    };

    document.body.classList.toggle("mobile-menu-open", sidebarOpen);
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.classList.remove("mobile-menu-open");
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [sidebarOpen]);

  const handleAuthClick = async () => {
    if (user) {
      await logout();
      navigate("/auth");
      return;
    }

    navigate("/auth");
  };

  return (
    <>
      <BannerSlider />
      <header
        className="site-header mo-left header style-2"
        style={{ zIndex: 98 }}
      >
        <div
          className={`sticky-header main-bar-wraper navbar-expand-lg ${
            headerFix ? "is-fixed" : ""
          }`}
        >
          <div className="main-bar clearfix">
            <div className="container clearfix">
              {/* <!-- Website Logo --> */}
              <div className="logo-header mostion logo-light">
                <Link to="/">
                  <img
                    className="hpa-nav-logo"
                    src={IMAGES.logoWhite}
                    alt="Hybrid Performance Academy"
                  />
                </Link>
              </div>
              <div className="logo-header mostion logo-dark">
                <Link to="/">
                  <img
                    className="hpa-nav-logo"
                    src={IMAGES.logo}
                    alt="Hybrid Performance Academy"
                  />
                </Link>
              </div>
              <button
                className={`navbar-toggler navicon justify-content-end ${
                  sidebarOpen ? "open" : "collapsed"
                }`}
                type="button"
                onClick={() => setSidebarOpen(!sidebarOpen)}
                aria-expanded={sidebarOpen}
                aria-controls="navbarNavDropdown"
              >
                <span></span>
                <span></span>
                <span></span>
              </button>
              {/* <!-- Extra Nav --> */}
              <div className="extra-nav">
                <div className="extra-cell">
                  <button
                    type="button"
                    className="hpa-language-switch"
                    onClick={toggleLanguage}
                    aria-label={isArabic ? "Switch to English" : "التبديل إلى العربية"}
                  >
                    <i className="fa-solid fa-globe" aria-hidden="true" />
                    <span>{isArabic ? "EN" : "العربية"}</span>
                  </button>
                  <button
                    type="button"
                    onClick={handleAuthClick}
                    className="btn btn-skew appointment-btn d-xl-block d-none"
                  >
                    <span>{t(user ? "LOGOUT" : "LOGIN")}</span>
                  </button>
                </div>
              </div>
              {/* <!-- Extra Nav --> */}

              {/* <!-- Search Form --> */}
              <div className="dz-quik-search">
                <form action="#">
                  <input
                    name="search"
                    value=""
                    type="text"
                    className="form-control"
                    placeholder="Enter Your Keyword ..."
                  />
                  <span id="quik-search-remove">
                    <i className="fa-solid fa-xmark"></i>
                  </span>
                </form>
              </div>

              {/* <!-- Header Nav --> */}
              <div
                id="navbarNavDropdown"
                className={`header-nav navbar-collapse collapse justify-content-end ${
                  sidebarOpen ? "show" : ""
                }`}
              >
                <div className="logo-header logo-dark">
                  <Link to="/">
                    <img
                      className="hpa-nav-logo"
                      src={IMAGES.logo}
                      alt="Hybrid Performance Academy"
                    />
                  </Link>
                </div>
                <ul className="nav navbar-nav navbar navbar-left">
                  {MenuListArray2.filter(
                    (item) => !item.feature || (item.feature === "nutrition_guide" && nutritionGuideAccess)
                  ).map((item, index) => {
                    let menuClass = item.classChange;
                    if (menuClass !== "sub-menu-down") {
                      return (
                        <li
                          className={`${menuClass} ${
                            item.title === activeMenu ? "active" : ""
                          }`}
                          // className={`${ menuClass} ${ location.pathname == item.to ? 'active'  : '' }`}

                          key={index}
                        >
                          <Link to={item.to} onClick={closeMobileMenu}>{t(item.title)}</Link>
                        </li>
                      );
                    } else {
                      return (
                        <li
                          className={`${menuClass} ${
                            state.active === item.title ? "open active" : ""
                          } ${item.title === activeMenu ? "active" : ""}`}
                          // <li className={`${ menuClass} ${ location.pathname == item.to ? 'active'  : '' }`}
                          key={index}
                        >
                          {item.content && item.content.length > 0 ? (
                            <>
                              <Link
                                to={"#"}
                                onClick={() => {
                                  handleMenuActive(item.title);
                                }}
                              >
                                {t(item.title)}
                              </Link>
                              <Collapse
                                in={state.active === item.title ? true : false}
                              >
                                <ul
                                  className={`sub-menu ${
                                    menuClass === "mm-collapse" ? "open" : ""
                                  }`}
                                >
                                  {item.content &&
                                    item.content.map((data, index) => {
                                      //console.log('path loc', data.to );
                                      return (
                                        <li
                                          key={index}
                                          className={`${
                                            state.activeSubmenu === data.title
                                              ? "open"
                                              : ""
                                          }`}
                                          //className={`${ menuClass} ${ location.pathname == data.to ? 'active'  : '' }`}
                                        >
                                          {data.content &&
                                          data.content.length > 0 ? (
                                            <>
                                              <Link
                                                to={data.to}
                                                onClick={() => {
                                                  handleSubmenuActive(
                                                    data.title
                                                  );
                                                }}
                                              >
                                                {data.title}
                                                <i className="fa fa-angle-right" />
                                              </Link>
                                              <Collapse
                                                in={
                                                  state.activeSubmenu ===
                                                  data.title
                                                    ? true
                                                    : false
                                                }
                                              >
                                                <ul
                                                  className={`sub-menu ${
                                                    menuClass === "mm-collapse"
                                                      ? "open"
                                                      : ""
                                                  }`}
                                                >
                                                  {data.content &&
                                                    data.content.map(
                                                      (data, index) => {
                                                        return (
                                                          <>
                                                            <li key={index}>
                                                              <Link
                                                                to={data.to}
                                                              >
                                                                {data.title}
                                                              </Link>
                                                            </li>
                                                          </>
                                                        );
                                                      }
                                                    )}
                                                </ul>
                                              </Collapse>
                                            </>
                                          ) : (
                                            <Link to={data.to}>
                                              {data.title}
                                            </Link>
                                          )}
                                        </li>
                                      );
                                    })}
                                </ul>
                              </Collapse>
                            </>
                          ) : (
                            <Link to={item.to} onClick={closeMobileMenu}>{t(item.title)}</Link>
                          )}
                        </li>
                      );
                    }
                  })}
                </ul>
                <div className="mobile-drawer-auth">
                  <button
                    type="button"
                    className="hpa-language-switch hpa-language-switch-mobile"
                    onClick={toggleLanguage}
                  >
                    <i className="fa-solid fa-globe" aria-hidden="true" />
                    <span>{isArabic ? "English" : "العربية"}</span>
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      closeMobileMenu();
                      handleAuthClick();
                    }}
                    className="btn btn-primary btn-skew w-100"
                  >
                    <span>{t(user ? "LOGOUT" : "LOGIN")}</span>
                  </button>
                </div>
                <div className="dz-social-icon">
                  <ul>
                    <li>
                      <a target="_blank" href={INSTAGRAM_URL} rel="noreferrer" aria-label="Instagram">
                        <i className="fab fa-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- Main Header End --> */}
      </header>
    </>
  );
};

export default Header2;
